import makeApp from "../shared/make_app";

import * as dhsa from "../shared/actions/data_hub_search";
import * as loadingActions from "../shared/actions/loading";
import * as focusViewActions from "./actions/focus_view";
import Root from "./containers/root";
import { applyRegulationStandardsListFilter } from "./middlewares";

const focusView = (state = {}, action) => {
  switch(action.type) {
  case focusViewActions.SWITCH_TO_PARAMETER_DETAIL:
    return Object.assign({}, state, {
      type: action.payload.focusViewType,
      lockFilterBox: true,
      regulation: null,
      parameter: {
        data: {
          parameter: action.payload.parameter,
          country: action.payload.country
        },
        title: `Standards for ${action.payload.purpose.label} (${action.payload.parameter.name}) in ${action.payload.country.name}`
      }
    });
  case focusViewActions.BREADCRUMBS_CLICK_PARAMETER:
    return Object.assign({}, state, {
      type: action.payload.focusViewType,
      regulation: null
    });
  case focusViewActions.BREADCRUMBS_CLICK_OVERVIEW:
  case dhsa.SAVED_SEARCH_SELECTED:
    return {
      type: focusViewActions.FOCUS_VIEW_OVERVIEW,
      lockFilterBox: false,
      overview: {
        title: "Overview of parameters by country"
      }
    };
  case loadingActions.DATA_LOADED:
    return Object.assign({}, state, { lockFilterBox: state.type !== focusViewActions.FOCUS_VIEW_OVERVIEW });
  default:
    return state;
  }
};

export default makeApp(Root, focusView, [applyRegulationStandardsListFilter]);
